import React from 'react';

import { Typography } from '@material-ui/core';
import {
  CheckOutlined as CheckOutlinedIcon,
  ClearOutlined as ClearOutlinedIcon
} from '@material-ui/icons';
import { ButtonField, Step } from '../SteppedForm';

const StepCabsure = (props) => {
  return (
    <Step
      id="cabsure"
      nonext
      title="Cabsure Insurance"
      skip={() => props.getVehicle().carbuyfin !== 'neither'}>
      <Typography variant="body1" paragraph>
        Would you like to enquire about our Cabsure taxi insurance options and have one of our staff contact you?
      </Typography>
      <br />
      <ButtonField
        id="requested_cabsure_insurance_quote"
        value={true}
        label="Yes"
        className="TopIconButton"
        startIcon={<CheckOutlinedIcon />}
      />
      <ButtonField
        id="requested_cabsure_insurance_quote"
        value={false}
        label="No"
        className="TopIconButton"
        startIcon={<ClearOutlinedIcon />}
      />
    </Step>
  );
};

export default StepCabsure;
